import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL?.trim();
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim();

if (!url || !publishableKey) {
  throw new Error("Precise Plate production Supabase settings are missing.");
}

export const supabase = createClient(url, publishableKey, {
  db: { schema: import.meta.env.VITE_SUPABASE_DB_SCHEMA?.trim() || "precise_plate" },
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: "precise-plate-auth",
  },
}) as SupabaseClient;
